import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Tag,
  TimePicker,
} from "antd";
import Text from "../../../components/Text/Text";
import {
  ArrowRightOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import DatePicker from "../../../components/DatePicker/DatePicker";
import { color } from "../../../resource";

export const FlashSaleStepTwo: React.FC<{ form: any }> = ({ form }) => {
  const [confirmFilterRound, setConfirmFilterRound] = useState<any>({
    action: "",
    open: false,
    date: undefined,
  });
  const advanceTimeOptions = [
    { value: "HOUR_1", label: "1 ชั่วโมงก่อนเริ่ม", key: "HOUR_1", calculate: "hour" },
    { value: "DAY_1", label: "1 วันก่อนเริ่ม", key: "DAY_1", calculate: 1 },
    { value: "DAY_3", label: "3 วันก่อนเริ่ม", key: "DAY_3", calculate: 3 },
    { value: "DAY_7", label: "7 วันก่อนเริ่ม", key: "DAY_7", calculate: 7 },
    { value: "CUSTOM", label: "กำหนดวันและเวลาเอง", key: "CUSTOM", calculate: "custom" },
  ];
  const watchTimeSlotList = Form.useWatch("rounds", form);
  const watchStartDate = Form.useWatch("mainStartDate", form);
  const watchPrelaunchPreview = Form.useWatch("prelaunchPreview", form);

  useEffect(() => {
    if (form.getFieldValue("rounds")?.length === 0) {
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        rounds: [
          {
            roundNo: 1,
            startDate: undefined,
            endDate: undefined,
            startTime: undefined,
            endTime: undefined,
            products: [],
            searchProducts: [],
          },
        ],
      });
    }
  }, []);

  const onAddTimeSlot = () => {
    const cartLockTime = form.getFieldValue("cartLockTime");
    const timeSlotList = form.getFieldValue("rounds") || [];
    if (timeSlotList.length < 5) {
      const newTimeSlotList = timeSlotList.map((slot, index) => {
        return {
          ...slot,
          startDate: index === 0 ? form.getFieldValue("mainStartDate") : slot.startDate,
          endDate: slot.endDate === form.getFieldValue("mainEndDate") ? undefined : slot.endDate,
        };
      });
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        rounds: [
          ...newTimeSlotList,
          {
            roundNo: timeSlotList.length + 1,
            startDate: undefined,
            startTime: cartLockTime
              ? timeSlotList[timeSlotList.length - 1].endTime.add(cartLockTime, "minute")
              : undefined,
            endDate: form.getFieldValue("mainEndDate")
              ? form.getFieldValue("mainEndDate")
              : undefined,
            endTime: undefined,
          },
        ],
      });
    }
  };
  const onDeleteTimeSlot = async (index: number) => {
    const timeSlotList = form.getFieldValue("rounds") || [];
    const newTimeSlotList = timeSlotList.filter((_: any, i: number) => i !== index);
    if (timeSlotList.length > 1) {
      if (`${index}` === `${newTimeSlotList.length}`) {
        const mapDate = await newTimeSlotList.map((slot, i) => {
          if (`${i}` === `${newTimeSlotList.length - 1}`) {
            return {
              ...slot,
              endDate: form.getFieldValue("mainEndDate")
                ? form.getFieldValue("mainEndDate")
                : undefined,
            };
          }
          return slot;
        });
        form.setFieldsValue({
          ...form.getFieldsValue(true),
          rounds: mapDate,
        });
      } else {
        form.setFieldsValue({
          ...form.getFieldsValue(true),
          rounds: newTimeSlotList,
        });
      }
    }
  };
  const checkValidateDate = () => {
    if (confirmFilterRound?.action === "startDate") {
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        mainStartDate: confirmFilterRound.date,
        rounds: [
          {
            roundNo: 1,
            startDate: confirmFilterRound.date,
            startTime: undefined,
            endDate: form.getFieldValue("mainEndDate")
              ? form.getFieldValue("mainEndDate")
              : undefined,
            endTime: undefined,
          },
        ],
        prelaunchPreview: undefined,
        previewDate: undefined,
        previewTime: undefined,
      });
    } else {
      const rounds = form.getFieldValue("rounds") || [];
      const filterData = rounds.filter((round: any) => round.endDate < confirmFilterRound.date);
      const newMap = filterData.map((round: any, index: number) => {
        if (index === filterData.length - 1) {
          return {
            ...round,
            endDate: confirmFilterRound.date,
          };
        }
        return {
          ...round,
        };
      });

      form.setFieldsValue({
        ...form.getFieldsValue(true),
        mainEndDate: confirmFilterRound.date,
        rounds:
          newMap.length > 0
            ? newMap
            : [
                {
                  roundNo: 1,
                  startDate: form.getFieldValue("mainStartDate")
                    ? form.getFieldValue("mainStartDate")
                    : undefined,
                  startTime: undefined,
                  endDate: confirmFilterRound.date,
                  endTime: undefined,
                },
              ],
      });
    }
  };

  return (
    <>
      <div>
        <span
          className='card-label font-weight-bolder text-dark'
          style={{ fontSize: 20, fontWeight: "bold" }}
        >
          ระยะเวลาการจัด Flash Sale
        </span>
      </div>
      <Text color='Text3' level={6}>
        กำหนดการจัดแคมเปญได้สูงสุด 5 วัน
      </Text>
      <Form form={form} layout='vertical' autoComplete='off'>
        <Row justify={"space-between"} gutter={8} style={{ marginTop: 25 }}>
          <Col span={12}>
            <Form.Item
              label='วันที่เริ่มต้น Flash Sale'
              name='mainStartDate'
              rules={[{ required: true, message: "โปรดระบุวันที่เริ่มต้น Flash Sale" }]}
              required
            >
              <DatePicker
                value={form.getFieldValue("mainStartDate")}
                suffixIcon={<CalendarOutlined />}
                placeholder='เลือกวันที่เริ่มต้น'
                style={{ width: "100%" }}
                enablePast
                disabledDate={(current: Dayjs) => {
                  const dateToday = dayjs();
                  const endDate = form.getFieldValue("mainEndDate");
                  const maxDate = dayjs(endDate).add(-4, "day");
                  return (
                    current &&
                    (current.isBefore(dateToday) ||
                      (endDate && current.isAfter(endDate)) ||
                      (maxDate && current.isBefore(maxDate)))
                  );
                }}
                onChange={(date) => {
                  const checkDate = form
                    .getFieldValue("rounds")
                    .filter(
                      (round: any) =>
                        (round.startDate && round.startDate.isAfter(date)) ||
                        (round.endDate && round.endDate.isAfter(date)) ||
                        (round.startDate && round.startDate.isBefore(date)) ||
                        (round.endDate && round.endDate.isBefore(date)),
                    );
                  if (checkDate.length > 0) {
                    setConfirmFilterRound({ action: "startDate", open: true, date: date });
                  } else {
                    form.setFieldValue("mainStartDate", date);
                    form.setFieldValue(["rounds", 0, "startDate"], date);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col style={{ paddingTop: "30px" }}>
            <ArrowRightOutlined />
          </Col>
          <Col span={11}>
            <Form.Item
              label='วันที่สิ้นสุด Flash Sale '
              name='mainEndDate'
              rules={[{ required: true, message: "โปรดระบุวันที่สิ้นสุด Flash Sale" }]}
              required
            >
              <DatePicker
                value={form.getFieldValue("mainEndDate")}
                suffixIcon={<CalendarOutlined />}
                placeholder='เลือกวันที่สิ้นสุด'
                style={{ width: "100%" }}
                enablePast
                disabledDate={(current: Dayjs) => {
                  const dateToday = dayjs();
                  const startDate = form.getFieldValue("mainStartDate");
                  const maxDate = dayjs(startDate).add(4, "day");
                  return (
                    (current && startDate && current.isBefore(dateToday)) ||
                    current.isBefore(dayjs(startDate)) ||
                    current.isAfter(maxDate)
                  );
                }}
                onChange={(date) => {
                  const checkDate = form
                    .getFieldValue("rounds")
                    .filter(
                      (round: any) =>
                        (round.startDate && round.startDate.isAfter(date)) ||
                        (round.endDate && round.endDate.isAfter(date)),
                    );
                  if (checkDate.length > 0) {
                    setConfirmFilterRound({ action: "endDate", open: true, date: date });
                  } else {
                    form.setFieldValue("mainEndDate", date);
                    const roundsData = form.getFieldValue("rounds");
                    form.setFieldValue(["rounds", roundsData.length - 1, "endDate"], date);
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Text fontWeight={600} level={4}>
          รอบเวลา (Time Slot)
        </Text>
        <br />
        <Text color='Text3' level={6}>
          ตั้งค่ารอบเวลาได้สูงสุด 5 รอบ · รอบเวลาสามารถข้ามวันได้
        </Text>
        {form.getFieldValue("cartLockTime") > 0 && (
          <Alert
            description={`ทุกรอบเวลาต้องเว้นระยะห่างจากรอบก่อนหน้าอย่างน้อย ${form.getFieldValue("cartLockTime")} นาที เนื่องจากตะกร้าที่ล็อกสินค้า (Cart Lock) จะล็อคได้ทีละรอบ`}
            showIcon
            icon={<ExclamationCircleOutlined />}
            style={{
              padding: "10px",
              borderRadius: "8px",
              backgroundColor: "#F3F6F9",
              border: "none",
            }}
          />
        )}
        <Form.Item name='rounds'>
          {form
            .getFieldValue("rounds")
            ?.map((item: any, index: number) => (
              <CardTimeSlot
                key={index}
                index={index}
                form={form}
                onDeleteTimeSlot={onDeleteTimeSlot}
              />
            ))}
        </Form.Item>
        <div
          style={{
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            type='dashed'
            icon={
              <PlusOutlined
                style={{
                  color: form.getFieldValue("rounds")?.length < 5 ? color.primary : color.Text3,
                }}
              />
            }
            style={{
              width: "100%",
              height: "40px",
              borderColor: form.getFieldValue("rounds")?.length < 5 ? color.primary : color.Text3,
            }}
            onClick={onAddTimeSlot}
          >
            <Text
              fontSize={16}
              color={form.getFieldValue("rounds")?.length < 5 ? "primary" : "Text3"}
            >
              เพิ่มรอบเวลา
            </Text>
          </Button>
        </div>
        <Divider />
        <>
          <Text fontWeight={600} level={4}>
            ระยะเวลาที่ให้ร้านเห็นแคมเปญล่วงหน้า (Pre-launch Preview)
          </Text>
          <br />
          <Text color='Text3' level={6}>
            ร้านค้าจะเห็นแคมเปญ และดูสินค้าเบื้องต้นได้
            แต่ยังสั่งซื้อไม่ได้จนกว่าแคมเปญจะเริ่มขายจริง
          </Text>
          <Row justify={"start"} gutter={8} style={{ marginTop: 12 }}>
            <Col span={12}>
              <Form.Item
                label='ระยะเวลาที่ให้ร้านเห็นแคมเปญล่วงหน้า'
                name='prelaunchPreview'
                rules={[{ required: true, message: "กรุณาเลือกระยะเวลาที่แสดงล่วงหน้า" }]}
              >
                <Select
                  style={{ height: "40px" }}
                  disabled={form.getFieldValue("mainStartDate") === undefined}
                  options={
                    advanceTimeOptions.map((option) => ({
                      ...option,
                      disabled:
                        dayjs(form.getFieldValue("mainStartDate")).add(-option.calculate, "day") <=
                        dayjs().startOf("day"),
                    })) || []
                  }
                  placeholder='เลือกระยะเวลาที่แสดงล่วงหน้า'
                  onChange={(value) => {
                    const mainStartDate = form.getFieldValue("mainStartDate");
                    const firstRound = form.getFieldValue("rounds")?.[0];
                    if (value === "HOUR_1") {
                      if (firstRound?.startDate && firstRound?.startTime) {
                        const firstRoundDateTime = dayjs(
                          `${dayjs(firstRound.startDate).format("YYYY-MM-DD")} ${dayjs(
                            firstRound.startTime,
                          ).format("HH:mm")}`,
                          "YYYY-MM-DD HH:mm",
                        );
                        const previewDateTime = firstRoundDateTime.subtract(1, "hour");
                        form.setFieldValue("previewDate", previewDateTime);
                        form.setFieldValue("previewTime", previewDateTime);
                      } else {
                        form.setFieldValue("previewDate", undefined);
                        form.setFieldValue("previewTime", undefined);
                      }
                    } else if (value === "DAY_1") {
                      form.setFieldValue("previewDate", dayjs(mainStartDate).add(-1, "day"));
                      form.setFieldValue("previewTime", dayjs("00:00", "HH:mm"));
                    } else if (value === "DAY_3") {
                      form.setFieldValue("previewDate", dayjs(mainStartDate).add(-3, "day"));
                      form.setFieldValue("previewTime", dayjs("00:00", "HH:mm"));
                    } else if (value === "DAY_7") {
                      form.setFieldValue("previewDate", dayjs(mainStartDate).add(-7, "day"));
                      form.setFieldValue("previewTime", dayjs("00:00", "HH:mm"));
                    } else {
                      form.setFieldValue("previewDate", undefined);
                      form.setFieldValue("previewTime", undefined);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {watchPrelaunchPreview && (
              <>
                <Col span={7}>
                  <Form.Item
                    name='previewDate'
                    label='วันที่เริ่มเห็นแคมเปญ'
                    rules={[
                      {
                        required: true,
                        message: "*โปรดเลือกวันที่เห็นแคมเปญ",
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={form.getFieldValue("prelaunchPreview") !== "CUSTOM"}
                      suffixIcon={<CalendarOutlined />}
                      style={{ width: "100%" }}
                      enablePast
                      disabledDate={(current: Dayjs) => {
                        const endDate = form.getFieldValue("mainEndDate");
                        const startRound = form.getFieldValue(["rounds", 0, "startDate"]);
                        const startRoundTime = form.getFieldValue(["rounds", 0, "startTime"]);
                        const startRoundDateTime =
                          startRound && startRoundTime
                            ? dayjs(
                                `${dayjs(startRound).format("YYYY-MM-DD")} ${dayjs(
                                  startRoundTime,
                                ).format("HH:mm")}`,
                                "YYYY-MM-DD HH:mm",
                              )
                            : null;

                        const currentDate = current.startOf("day");
                        return (
                          currentDate.isBefore(dayjs(), "day") ||
                          (startRoundDateTime &&
                            currentDate.isAfter(startRoundDateTime.startOf("day"), "day")) ||
                          (endDate && currentDate.isAfter(dayjs(endDate).startOf("day"), "day"))
                        );
                      }}
                      onChange={(date) => {
                        const dateToday = dayjs();
                        if (date && date.isSame(dateToday.startOf("day"), "day")) {
                          form.setFieldValue("previewTime", dayjs(dateToday, "HH:mm"));
                        } else {
                          form.setFieldValue("previewTime", null);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item
                    name='previewTime'
                    label='เวลาที่เริ่มเห็นแคมเปญ'
                    rules={[
                      {
                        required: true,
                        message: "*โปรดเลือกเวลาที่เริ่มเห็นแคมเปญ",
                      },
                    ]}
                  >
                    <TimePicker
                      disabled={form.getFieldValue("prelaunchPreview") === "HOUR_1"}
                      style={{ width: "100%", color: "black", height: "40px" }}
                      allowClear={false}
                      showNow={false}
                      suffixIcon={<ClockCircleOutlined />}
                      needConfirm={false}
                      format='HH:mm'
                      inputReadOnly
                      disabledTime={() => {
                        const previewDate = form.getFieldValue("previewDate");
                        const startRound = form.getFieldValue(["rounds", 0, "startDate"]);
                        const startRoundTime = form.getFieldValue(["rounds", 0, "startTime"]);

                        if (!previewDate || !startRound || !startRoundTime) {
                          return {};
                        }

                        const previewDay = dayjs(previewDate);
                        const startRoundDay = dayjs(startRound);
                        const now = dayjs();

                        const isPreviewToday = previewDay.isSame(now, "day");
                        const isSameStartRoundDay = previewDay.isSame(startRoundDay, "day");
                        const disabledHours: number[] = [];

                        if (isPreviewToday) {
                          const currentHour = now.hour();
                          for (let hour = 0; hour < currentHour; hour++) {
                            disabledHours.push(hour);
                          }
                        }

                        let startRoundHour: number | null = null;
                        let startRoundMinute: number | null = null;

                        if (isSameStartRoundDay) {
                          const startTime = dayjs(startRoundTime);
                          startRoundHour = startTime.hour();
                          startRoundMinute = startTime.minute();
                          for (let hour = startRoundHour + 1; hour < 24; hour++) {
                            disabledHours.push(hour);
                          }
                        }
                        return {
                          disabledHours: () => [...new Set(disabledHours)],
                          disabledMinutes: (selectedHour) => {
                            const disabledMinutes: number[] = [];
                            if (isPreviewToday && selectedHour === now.hour()) {
                              for (let minute = 0; minute <= now.minute(); minute++) {
                                disabledMinutes.push(minute);
                              }
                            }
                            if (
                              isSameStartRoundDay &&
                              selectedHour === startRoundHour &&
                              startRoundMinute !== null
                            ) {
                              for (let minute = startRoundMinute; minute < 60; minute++) {
                                disabledMinutes.push(minute);
                              }
                            }
                            return [...new Set(disabledMinutes)];
                          },
                          disabledSeconds: () => [],
                        };
                      }}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </>
      </Form>
      {confirmFilterRound.open && (
        <Modal
          title={
            <Text fontWeight={600} level={4}>
              ยืนยันการปรับเปลี่ยนระยะเวลา
            </Text>
          }
          centered
          open={confirmFilterRound.open}
          onOk={() => {
            checkValidateDate();
            setConfirmFilterRound({ action: "", open: false });
          }}
          onCancel={() => setConfirmFilterRound({ action: "", open: false })}
          okText='ยืนยัน'
          cancelText='ยกเลิก'
          okButtonProps={{ style: { backgroundColor: color.error, color: "#fff" } }}
          cancelButtonProps={{ style: { borderColor: color.error, color: color.error } }}
        >
          <Text>
            เนื่องจากมีการปรับเปลี่ยนระยะเวลาจัด Flash Sale ที่ไม่ตรงกับรอบเวลา ระบบจะทำการ
            <Text color='error'>ลบรอบเวลา</Text>เพื่อให้สอดคล้องกับระยะเวลาที่ปรับเปลี่ยน
          </Text>
        </Modal>
      )}
    </>
  );
};

const CardTimeSlot: React.FC<{
  index: number;
  form: any;
  onDeleteTimeSlot: (index: number) => void;
}> = ({ index, form, onDeleteTimeSlot }) => {
  const watchStartDate = form.getFieldValue("mainStartDate");
  const watchEndDate = form.getFieldValue("mainEndDate");

  const roundData = form.getFieldValue("rounds");
  const watchRound = form.getFieldValue(["rounds", index]);

  const calculateTime = () => {
    const dataRound = form.getFieldValue(["rounds", index]);
    if (
      !dataRound?.startDate ||
      !dataRound?.startTime ||
      !dataRound?.endDate ||
      !dataRound?.endTime
    ) {
      return { hours: 0, minutes: 0 };
    }
    const start = dataRound?.startDate
      ?.clone()
      .hour(dataRound?.startTime.hour())
      .minute(dataRound?.startTime.minute());
    const end = dataRound?.endDate
      ?.clone()
      .hour(dataRound?.endTime.hour())
      .minute(dataRound?.endTime.minute());
    const duration = end?.diff(start, "minute") || 0;
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    return { hours, minutes };
  };

  const checkValidate = async () => {
    const dataRounds = form.getFieldValue("rounds") || [];
    let isValid = true;
    for (let i = 0; i < dataRounds.length; i++) {
      const round = dataRounds[i];
      if (!round.startDate || !round.startTime || !round.endDate || !round.endTime) {
        isValid = false;
        continue;
      }
      const start = dayjs(round.startDate)
        .hour(round.startTime.hour())
        .minute(round.startTime.minute())
        .second(0);

      const end = dayjs(round.endDate)
        .hour(round.endTime.hour())
        .minute(round.endTime.minute())
        .second(0);

      if (!start.isBefore(end)) {
        isValid = false;
        form.setFields([
          {
            name: ["rounds", i, "endTime"],
            errors: ["*เวลาสิ้นสุดต้องมากกว่าเวลาเริ่มต้น"],
          },
        ]);
      } else {
        form.setFields([
          {
            name: ["rounds", i, "endTime"],
            errors: [],
          },
        ]);
      }

      if (i > 0) {
        const previousRound = dataRounds[i - 1];
        if (
          previousRound.startDate &&
          previousRound.startTime &&
          previousRound.endDate &&
          previousRound.endTime
        ) {
          const previousEnd = dayjs(previousRound.endDate)
            .hour(previousRound.endTime.hour())
            .minute(previousRound.endTime.minute())
            .second(0);

          if (start.isBefore(previousEnd)) {
            isValid = false;

            form.setFields([
              {
                name: ["rounds", i, "startDate"],
                errors: ["*วันที่ซ้อนทับกับรอบก่อนหน้า"],
              },
              {
                name: ["rounds", i, "startTime"],
                errors: ["*เวลาซ้อนทับกับรอบก่อนหน้า"],
              },
            ]);
          } else {
            form.setFields([
              {
                name: ["rounds", i, "startDate"],
                errors: [],
              },
              {
                name: ["rounds", i, "startTime"],
                errors: [],
              },
            ]);
          }
        }
      }
      try {
        await form.validateFields([
          ["rounds", i, "startDate"],
          ["rounds", i, "endDate"],
          ["rounds", i, "startTime"],
          ["rounds", i, "endTime"],
        ]);
      } catch (error) {
        console.log(error);
        isValid = false;
      }
    }
    return isValid;
  };

  return (
    <div style={{ paddingBottom: 10, paddingTop: 10 }} key={index}>
      <Form.Item name={["rounds", index]} noStyle>
        <Card bodyStyle={{ padding: 18, backgroundColor: "#FAFAFA" }} style={{ borderRadius: 8 }}>
          <Row justify={"space-between"}>
            <Col>
              <Row gutter={8} align='middle'>
                <Col>
                  <ClockCircleOutlined style={{ fontSize: "20px" }} />
                </Col>
                <Col>
                  <Text fontWeight={600}>รอบที่ {index + 1}</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Tag style={{ backgroundColor: "#E6EEFA", border: "none" }}>
                <Text color='primary' level={6}>
                  {calculateTime().hours} ชม. {calculateTime().minutes} นาที
                </Text>
              </Tag>
            </Col>
          </Row>
          <Row align='middle' gutter={8}>
            <Col span={11}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name={["rounds", index, "startDate"]}
                    label='วันที่เริ่มต้น'
                    required={index !== 0}
                  >
                    <DatePicker
                      disabled={index === 0}
                      suffixIcon={<CalendarOutlined />}
                      style={{ width: "100%", color: "black" }}
                      enablePast
                      disabledDate={(current: Dayjs) => {
                        const previousEndDate = form.getFieldValue([
                          "rounds",
                          index - 1,
                          "endDate",
                        ]);
                        const previousEndTime = form.getFieldValue([
                          "rounds",
                          index - 1,
                          "endTime",
                        ]);
                        const mainEndDate = form.getFieldValue("mainEndDate");
                        if (!current) {
                          return false;
                        }
                        let previousEnd: Dayjs | null = null;
                        if (previousEndDate && previousEndTime) {
                          previousEnd = dayjs(previousEndDate)
                            .hour(dayjs(previousEndTime).hour())
                            .minute(dayjs(previousEndTime).minute())
                            .second(0);
                        }
                        return (
                          (mainEndDate && current.isAfter(dayjs(mainEndDate), "day")) ||
                          (watchStartDate && current.isBefore(dayjs(watchStartDate), "day")) ||
                          (previousEnd && current.isBefore(previousEnd.add(1, "minute"), "day"))
                        );
                      }}
                      onChange={() => {
                        //form.validateFields([["rounds", index, "startTime"]]);
                        checkValidate();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={["rounds", index, "startTime"]}
                    label='เวลาเริ่ม'
                    initialValue={dayjs("00:00", "HH:mm")}
                  >
                    <TimePicker
                      style={{ width: "100%", color: "black", height: "40px" }}
                      allowClear={false}
                      showNow={false}
                      suffixIcon={<ClockCircleOutlined />}
                      needConfirm={false}
                      format={"HH:mm"}
                      inputReadOnly
                      disabledTime={() => {
                        const cartLockTime = form.getFieldValue("cartLockTime");
                        const startDate = form.getFieldValue(["rounds", index, "startDate"]);
                        const endDate = form.getFieldValue(["rounds", index - 1, "endDate"]);
                        const endTime = form.getFieldValue(["rounds", index - 1, "endTime"]);
                        if (!startDate || !endDate || !endTime) {
                          return {};
                        }
                        if (!dayjs(startDate).isSame(dayjs(endDate), "day")) {
                          return {};
                        }
                        const minEndTime = dayjs(endTime).add(cartLockTime, "minute");
                        const minHour = minEndTime.hour();
                        const minMinute = minEndTime.minute();

                        return {
                          disabledHours: () => Array.from({ length: minHour }, (_, i) => i),
                          disabledMinutes: (selectedHour) => {
                            if (selectedHour === minHour) {
                              return Array.from({ length: minMinute }, (_, i) => i);
                            }

                            return [];
                          },

                          disabledSeconds: () => [],
                        };
                      }}
                      onChange={() => {
                        checkValidate();
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col style={{ paddingTop: "8px" }}>
              <ArrowRightOutlined />
            </Col>
            <Col span={11}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name={["rounds", index, "endDate"]}
                    label='วันที่สิ้นสุด'
                    rules={[
                      {
                        required: true,
                        message: "*โปรดเลือกวันที่สิ้นสุด",
                      },
                      {
                        validator: async (_, value) => {
                          const startDate = form.getFieldValue(["rounds", index, "startDate"]);
                          const previousEndDate =
                            index > 0 ? form.getFieldValue(["rounds", index - 1, "endDate"]) : null;
                          if (
                            value &&
                            watchStartDate &&
                            (value.isBefore(watchStartDate, "day") ||
                              value.isAfter(watchEndDate, "day"))
                          ) {
                            return Promise.reject("*วันที่สิ้นสุดต้องอยู่ในช่วงระยะที่กำหนด");
                          }
                          if (value && startDate && value.isBefore(startDate, "day")) {
                            return Promise.reject("*วันที่สิ้นสุดต้องมากกว่าวันที่เริ่มต้น");
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={index === roundData.length - 1}
                      suffixIcon={<CalendarOutlined />}
                      style={{ width: "100%" }}
                      disabledDate={(current: Dayjs) => {
                        const startDate = form.getFieldValue(["rounds", index, "startDate"]);
                        const endDateFlase = form.getFieldValue("mainEndDate");
                        return (
                          current &&
                          (current.isBefore(dayjs(startDate)) ||
                            current.isAfter(dayjs(endDateFlase)))
                        );
                      }}
                      onChange={() => {
                        checkValidate();
                      }}
                      enablePast
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={["rounds", index, "endTime"]}
                    label='เวลาสิ้นสุด'
                    initialValue={dayjs("23:59", "HH:mm")}
                  >
                    <TimePicker
                      style={{ width: "100%", color: "black", height: "40px" }}
                      showNow={false}
                      allowClear={false}
                      suffixIcon={<ClockCircleOutlined />}
                      needConfirm={false}
                      format='HH:mm'
                      inputReadOnly
                      disabledTime={() => {
                        const startDate = form.getFieldValue(["rounds", index, "startDate"]);
                        const startTime = form.getFieldValue(["rounds", index, "startTime"]);
                        const endDate = form.getFieldValue(["rounds", index, "endDate"]);
                        if (!startDate || !startTime || !endDate) {
                          return {};
                        }
                        const startDateTime = dayjs(
                          `${dayjs(startDate).format("YYYY-MM-DD")} ${dayjs(startTime).format(
                            "HH:mm",
                          )}`,
                        );

                        const endDateValue = dayjs(endDate);

                        if (endDateValue.isSame(dayjs(startDate), "day")) {
                          const minEndTime = startDateTime.add(1, "minute");

                          const minHour = minEndTime.hour();
                          const minMinute = minEndTime.minute();

                          return {
                            disabledHours: () => Array.from({ length: minHour }, (_, i) => i),
                            disabledMinutes: (selectedHour) => {
                              if (selectedHour === minHour) {
                                return Array.from({ length: minMinute }, (_, i) => i);
                              }
                              return [];
                            },
                            disabledSeconds: () => [],
                          };
                        }
                        if (endDateValue.isAfter(dayjs(startDate), "day")) {
                          return {
                            disabledHours: () => [],
                            disabledMinutes: () => [],
                            disabledSeconds: () => [],
                          };
                        }
                        return {};
                      }}
                      onChange={() => {
                        checkValidate();
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={1} style={{ paddingTop: "8px", textAlign: "right" }}>
              <DeleteOutlined
                style={{
                  cursor: roundData?.length === 1 ? "not-allowed" : "pointer",
                  color: roundData?.length === 1 ? color.Disable : color.error,
                }}
                onClick={() => onDeleteTimeSlot(index)}
              />
            </Col>
          </Row>
        </Card>
      </Form.Item>
    </div>
  );
};
